import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import PosterTransitionComponent from 'components/poster-transition/poster-transition';
import { allSymbolFadeEnable, changeState } from 'components/ui-helper';
import { DOPrompts, DOScenes, GameType, GFCustomLayers } from 'names/do-names';
import HidePromoFSonFreespins from 'slotworks/commands/promo-free-spins/hide-pfs-on-freespins';
import Components from 'slotworks/components/components';
import PromptContent from 'slotworks/components/prompt/prompt-content';
import Layers from 'slotworks/graphics/layers/layers';
import RevolverExitFreespins from 'slotworks/integration/revolver/states/revolver-exit-freespins';
import Bet from 'slotworks/model/bets/bet-model';
import GameState from 'slotworks/model/game-state';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import soundManager from 'slotworks/sound/sound-manager';
import GameInit from 'states/game-init';
import WildSticky from './wild-sitcky';

export default class ExitFreeSpin extends RevolverExitFreespins {
    public onEnter() {
        HidePromoFSonFreespins();
        GameInit.freeSpinsWin = GameState.getCurrentGame().getRunningFreespinsWinTotal();
        Components.betBar.setCurrentWin(GameInit.freeSpinsWin);
        Components.betBar.winnings.setWinnings(GameInit.freeSpinsWin);
        const prompt = new PromptContent([DOPrompts.EXIT_FREESPIN], 1000);
        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
        prompt.addContinueButton("continue");
        const bet = GameState.getCurrentGame().isBuyout ? GameState.getCurrentGame().totalBet : Bet.getTotalBet();
        let isBigWin = Components.bigWin.isBigWin(GameInit.freeSpinsWin, bet);
        allSymbolFadeEnable();
        if (isBigWin) {
            GameInit.freespinBigwin = true;
        }
        PosterTransitionComponent.onStarted.addOnce(() => {
            GameInit.gameType = GameType.default;
            Layers.Custom.get(GFCustomLayers.WILD_STICKY).show();
            WildSticky.onRecoveryWildStickyBehaviour();
            changeState(DOScenes.FREESPIN_TO_DEFAULT);
        });
        Layers.CelebrationBackground.setScene('freespins').execute();
        Components.prompt.showPrompt(prompt).then(() => {
            Layers.CelebrationBackground.defaultScene().execute();
            this.complete();
        });
    }

    public complete() {
        PosterTransitionComponent.onStarted.removeAll();
        Components.betBar.setCurrentWin(GameInit.freeSpinsWin);
        Components.betBar.winnings.setWinnings(GameInit.freeSpinsWin, GameInit.freeSpinsWin, 750);
        bonusBuyComponent.show();
        if (GameInit.freespinBigwin) {
            bonusBuyComponent.setEnabled(false);
        }
        super.complete();
    }
}



// WEBPACK FOOTER //
// ./src/states/exit-freespin.ts